// admin-panel/src/pages/SiteSettings.js
import React, { useEffect, useState } from "react";
import {
  Form, Input, Button, Card, Typography, message, Spin, Row, Col, Grid,
} from "antd";
import { SaveOutlined, GlobalOutlined } from "@ant-design/icons";
import { getSiteConfig, updateSiteConfig } from "../utilscopy/firebase";
const { Title, Text } = Typography;
const { TextArea } = Input;
const { useBreakpoint } = Grid;
export default function SiteSettings() {
const [form] = Form.useForm();
const [loading, setLoading] = useState(true);
const [saving, setSaving] = useState(false);
const screens = useBreakpoint();
const isMobile = !screens.sm;
useEffect(() => {
async function load() {
try {
const config = await getSiteConfig();
        form.setFieldsValue(config);
      } catch (e) {
        message.error("Failed to load settings");
      } finally {
setLoading(false);
      }
    }
load();
  }, []);
const handleSave = async (values) => {
setSaving(true);
try {
      await updateSiteConfig(values);
message.success("Site settings updated!");
} catch (e) {
message.error("Save failed");
} finally {
setSaving(false);
}
};
if (loading) {
return (
<div style={{ display: "flex", justifyContent: "center", padding: 80 }}>
<Spin size="large" />
</div>
    );
  }
return (
<div style={{ maxWidth: 700, width: "100%" }}>
<Card
style={{ borderRadius: 16, border: "1px solid #f0f0f0" }}
bodyStyle={{ padding: isMobile ? 16 : 24 }}
title={
<div style={{ display: "flex", alignItems: "center", gap: 10 }}>
<GlobalOutlined style={{ color: "#1677ff" }} />
<Title level={5} style={{ margin: 0 }}>General Site Settings</Title>
</div>
}
>
<Form form={form} layout="vertical" onFinish={handleSave}>
<Row gutter={[16, 0]}>
<Col xs={24}>
<Form.Item
name="name"
label="Site Name"
rules={[{ required: true, message: "Site name is required" }]}
>
<Input size="large" placeholder="ThoughtFlow" style={{ borderRadius: 10 }} />
</Form.Item>
</Col>
<Col xs={24}>
<Form.Item name="tagline" label="Tagline">
<Input placeholder="Ideas worth reading." style={{ borderRadius: 10 }} />
</Form.Item>
</Col>
<Col xs={24}>
<Form.Item name="description" label="Site Description">
<TextArea
rows={3}
placeholder="A brief description of your blog..."
style={{ borderRadius: 10 }}
/>
</Form.Item>
</Col>
<Col xs={24} sm={12}>
<Form.Item name="author" label="Default Author">
<Input style={{ borderRadius: 10 }} />
</Form.Item>
</Col>
<Col xs={24} sm={12}>
<Form.Item name="email" label="Contact Email">
<Input type="email" style={{ borderRadius: 10 }} />
</Form.Item>
</Col>
<Col xs={24}>
<Form.Item name="twitter" label="Twitter URL">
<Input style={{ borderRadius: 10 }} />
</Form.Item>
</Col>
<Col xs={24}>
<Form.Item name="github" label="GitHub URL">
<Input style={{ borderRadius: 10 }} />
</Form.Item>
</Col>
<Col xs={24}>
<Form.Item name="linkedin" label="LinkedIn URL">
<Input style={{ borderRadius: 10 }} />
</Form.Item>
</Col>
</Row>
<Button
type="primary"
htmlType="submit"
icon={<SaveOutlined />}
loading={saving}
size="large"
block={isMobile}
style={{ borderRadius: 10, background: "#111", borderColor: "#111", fontWeight: 700 }}
>
            Save Settings
</Button>
</Form>
</Card>
</div>
  );
}